var indentStyle = {"indentZero":"V6Y3R","indentOne":"CGznP","indentTwo":"Q-EsK","indentThree":"x9CCI","indentFour":"_2I0Ui","indentFive":"t0yP8","indentSix":"r-A-9"};

export { indentStyle as i };
//# sourceMappingURL=indentation-0b29e44f.js.map
